import { clientStampApi } from "api/client";
import { stampApi } from "api/master";

export default class StampService {
	create = (...args) => stampApi.create(...args);

	getDetail = () => stampApi.getDetail();

	reset = () => stampApi.reset();

	downloadCSV = () => stampApi.downloadCSV();

	scanStamp = (id) => clientStampApi.scanStamp(id);

	getScannedStamps = () => clientStampApi.getScannedStamps();
}
